import { ChangeDetectorRef, Component, Inject, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { CookieService } from 'ngx-cookie-service';
import { LayoutConfigService } from '../../../../core/_base/layout';
import { LayoutUtilsService, MessageType } from '../../../../core/_base/crud';
import { UserService } from '../../../../core/user/_services/user.service';
import { catchError, tap } from 'rxjs/operators';
import { of } from 'rxjs';

declare var hj: any;

@Component({
  selector: 'app-half-welcome-dialog',
  templateUrl: './half-welcome.dialog.component.html',
  styleUrls: ['./half-welcome.dialog.component.scss']
})
export class HalfWelcomeDialogComponent implements OnInit {
  loading: boolean;
  supportNumber: string;
  bannerImage: string;
  userInfoForm: FormGroup;
  siteName: string;
  countryNumber: string;

  constructor(
    public dialogRef: MatDialogRef<HalfWelcomeDialogComponent>,
    private cdr: ChangeDetectorRef,
    private fb: FormBuilder,
    private cookieService: CookieService,
    private layoutUtilsService: LayoutUtilsService,
    private layoutConfigService: LayoutConfigService,
    private userService: UserService,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) {
    this.countryNumber = `+${this.layoutConfigService.getConfig('site.countryNumber')}`;
    this.userInfoForm = this.fb.group({
      firstName: ['', Validators.required],
      lastName: ['', Validators.required],
      phone: [this.countryNumber, [Validators.required, Validators.pattern('^\\+?([0-9 ]{2,5})\\)?[-]?([0-9 ]{4})[-]?([0-9 ]{4,7})$')]],
      email: ['', Validators.pattern('^[A-Za-z0-9._%+-]+@[A-Za-z0-9.-]+.[A-Za-z]{2,6}$')],
    });
  }

  ngOnInit(): void {
    // const config = this.layoutConfigService.getConfig();
    this.supportNumber = this.layoutConfigService.getConfig('site.supportNumber');
    const bannerImage = this.layoutConfigService.getConfig('self.banner');
    this.bannerImage = bannerImage.substring(0, 4) === 'url(' ? 
      `linear-gradient(rgba(0,0,0,0.3), rgba(0,0,0,0.5), rgba(0,0,0,0.1)), ${bannerImage.split(",")[0]}` :
      bannerImage;
    this.siteName = this.layoutConfigService.getConfig('site.name');


    this.cookieService.delete('booking_details');

   
  }

  closeDialog() {
    this.dialogRef.close({event: 'cancel'});
  }


  setDefaultPic() {
    
    this.cdr.detectChanges();
  }

  onSubmit() {
    if (this.userInfoForm.invalid) {
      this.userInfoForm.markAllAsTouched();
      return;
    }
    this.loading = true
    let phoneNumber = this.userInfoForm.controls.phone.value;
    if (phoneNumber[0] !== "+") {
      phoneNumber = phoneNumber.replace(phoneNumber[0], this.countryNumber);
      this.userInfoForm.patchValue({
        phone: phoneNumber
      })
    }

    const payload = {
      firstName: this.userInfoForm.controls.firstName.value,
      lastName: this.userInfoForm.controls.lastName.value,
      phone: this.userInfoForm.controls.phone.value.replace(/ /g, ''),
      email: this.userInfoForm.controls.email.value
    };
    const visitor = {
      ...payload,
      // appName: this.siteName,
      referrer: this.data.referrer,
      url: this.data.url,
      userAgent: this.data.userAgent
    }
    if (!this.userInfoForm.controls.email.value) {
      delete visitor.email;
    }
    this.userService.saveVisitor(visitor).pipe(tap(response => {
      this.loading = false;
      if (response.success) {
        this.dialogRef.close({event: 'submit', payload});
      } else {
        this.layoutUtilsService.showActionNotification('Error saving data, please try again', MessageType.Read);
      }
    }), catchError(err => {
      this.loading = false;
      this.layoutUtilsService.showActionNotification(err.error.message[0] || 'Error saving data', MessageType.Read);
      return of(err);
    })).subscribe();

    if (hj) {
      hj('identify', payload.phone.replace('+', ''));
    }
    
  }

}
